
import { useTheme } from "@/context/ThemeContext";

// Dynamic text class helper to use across components
export const useTextColorClass = () => {
  const { theme } = useTheme();
  const isDark = theme === "dark";
  
  return {
    baseText: isDark ? "text-white" : "text-black",
    mutedText: isDark ? "text-white/80" : "text-black/80",
    subtleText: isDark ? "text-gray-300" : "text-gray-700",
    placeholderText: isDark ? "placeholder:text-gray-400" : "placeholder:text-gray-500",
    isDark
  };
};

// Component versions for JSX use
export const TextBase = ({ children, className = "" }: { children: React.ReactNode; className?: string }) => {
  const { baseText } = useTextColorClass();
  return <span className={`${baseText} ${className}`}>{children}</span>;
};

export const TextMuted = ({ children, className = "" }: { children: React.ReactNode; className?: string }) => {
  const { mutedText } = useTextColorClass();
  return <span className={`${mutedText} ${className}`}>{children}</span>;
};

export const TextSubtle = ({ children, className = "" }: { children: React.ReactNode; className?: string }) => {
  const { subtleText } = useTextColorClass();
  return <span className={`${subtleText} ${className}`}>{children}</span>;
};
